export default {
  auditReport: {
    search: '搜 索',
    reset: '重置',
    export: '导出',
    all: '全部',
    exportSuccess: '导出成功',
    exportError: '导出失败',
    fetchError: '查询失败',
    summary: {
      dateRange: '统计日期（+8）',
      dateRequired: '请选择日期范围',
      reportDate: '统计日期',
      branch: '分店',
      bet: '投注金额',
      payout: '返奖金额',
      ggr: 'GGR',
      headcountOfActive: '活跃投注玩家数',
      totalBet: '投注合计',
      totalPayout: '返奖合计',
      totalGgr: 'GGR 合计',
      totalActiveHc: '活跃投注玩家数',
    },
    gameType: {
      dateRange: '统计日期（+8）',
      dateRequired: '请选择日期范围',
      reportDate: '统计日期',
      gameType: '游戏类型',
      bet: '投注金额',
      payout: '返奖金额',
      ggr: 'GGR',
    },
    branchGameType: {
      dateRange: '统计日期（+8）',
      dateRequired: '请选择日期范围',
      reportDate: '统计日期',
      branch: '分店',
      gameType: '游戏类型',
      bet: '投注金额',
      payout: '返奖金额',
      ggr: 'GGR',
    },
    provider: {
      dateRange: '统计日期（+8）',
      dateRequired: '请选择日期范围',
      reportDate: '统计日期',
      provider: '游戏提供商',
      gameType: '游戏类型',
      betCount: '投注笔数',
      bet: '投注金额',
      payout: '返奖金额',
      ggr: 'GGR',
      total: '合计',
    },
    providerGameType: {
      dateRange: '统计日期（+8）',
      dateRequired: '请选择日期范围',
      reportDate: '统计日期',
      provider: '游戏提供商',
      gameType: '游戏类型',
      platformType: '平台类型',
      betCount: '投注笔数',
      bet: '投注金额',
      payout: '返奖金额',
      ggr: 'GGR',
      total: '合计',
    },
    gameOrder: {
      betTimeRange: '投注时间',
      dateRequired: '请选择投注时间范围',
      dateRangeMaxDays: '查询时间区间最多 {{days}} 天',
      providerFilter: '游戏提供商',
      betId: '注单 ID',
      betIdPlaceholder: '请输入注单 ID',
      partnerOrderId: '第三方注单 ID',
      flowIdPlaceholder: '请输入第三方注单 ID',
      userId: '玩家 ID',
      userIdPlaceholder: '请输入玩家 ID',
      userName: '会员账号',
      memberAccountPlaceholder: '请输入会员账号（精确）',
      channelType: '投注渠道',
      outletId: '分店/网点 ID',
      gameName: '游戏名称',
      gameType: '游戏类型',
      provider: '游戏提供商',
      platformType: '平台类型',
      platformCode: 'MX 平台标识',
      gameId: '三方游戏 ID',
      gameIdPlaceholder: '请输入游戏 ID',
      before: '下注前余额',
      after: '下注后余额',
      bet: '投注金额',
      validBets: '有效投注金额',
      payouts: '赔付金额',
      winLose: '输赢金额',
      refund: '返还金额',
      ggr: 'GGR',
      isBuyFeature: '是否购买免费游戏',
      result: '结算结果',
      status: '交易状态',
      betTime: '下注时间',
      settlementTime: '结算时间',
      detail: '操作',
      viewDetail: '查看详情',
      sportDetail: '赛事详情',
      casinoDetail: '电子详情',
      detailField: {
        // 基础信息兜底
        game_name: '游戏名称',
        game_id: '游戏 ID',
        game_brand: '游戏品牌',
        game_type: '游戏类型',
        // PAGCOR Casino Detail
        liveGameRound: '游戏回合 ID',
        jackpotContribution: 'Jackpot 贡献',
        jackpotPayout: 'Jackpot 派彩',
        houseRake: 'House Rake',
        rakeCeiling: 'Rake Ceiling',
        blinds: 'Blinds',
        netWin: '净赢金额',
        // 体育赛事扩展信息 (SportEventExtInfo)
        sportName: '运动类型',
        leagueName: '联赛名称',
        eventName: '赛事名称',
        matchDateTime: '开赛时间',
        handicap: '下注盘口',
        odds: '投注赔率',
        finalScore: '最终比分',
        itemStatus: '单项状态',
        settlementStatus: '结算状态',
        isLive: '是否滚球',
        yes: '是',
        no: '否',
      },
    },
    playerCount: {
      dateRange: '统计日期（+8）',
      dateRequired: '请选择日期范围',
      reportDate: '统计日期',
      dailyRegisteredHc: '日注册人数',
      dailyKycVerifiedHc: '日KYC认证人数',
      dailyKycPendingHc: '日KYC认证中人数',
      activeHc: '账户正常人数',
      deactivatedHc: '账户黑名单锁定人数',
    },
    playerAggregator: {
      dateRange: '统计日期（+8）',
      dateRequired: '请选择日期范围',
      reportDate: '统计日期',
      memberAccount: '会员账号',
      playerIdPlaceholder: '精确查询',
      outletId: '分店/网点 ID',
      channelType: '投注渠道',
      pageTotal: '本页合计',
      depositCount: '存款笔数',
      depositAmount: '存款金额',
      withdrawCount: '提款笔数',
      withdrawAmount: '提款金额',
      totalBetAmount: '总投注金额',
      totalPayoutAmount: '总赔付金额',
      winLoseAmount: '输赢金额',
    },
  },
};
